// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.containerLogin {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}

.caixa_img {
  width: 40vw;
  height: 94vh;
  margin-top: 3em;
  display: flex;
  justify-content: end;
  border-top-left-radius: 2em;
  border-top-right-radius: 2em;
  background-color: var(--cor-roxoEscuro);
}

.caixa_img img {
  width: 35vw;
}

.caixa_usuario {
  width: 30vw;
  margin-top: 6em;
  display: flex;
  align-items: center;
  flex-direction: column;
  font-family: "Inter";
}

.caixa_usuario img{
  width: 35%;
}

.caixa_usuario > button {
  width: 17vw;
  height: 4.5vh;
  margin: 1.5em;
  font-size: 1.1em;
  border-radius: 0.5em;
  border: none;
  color: var(--cor-branco);
  background-color: var(--cor-roxoEscuro);
  cursor: pointer;
}

.erro label,
.caixa_input label {
  font-size: 1em;
  margin-top: 1em;
  margin-bottom: 1em;
  display: flex;
}

.erro > input,
.caixa_input > input {
  width: 17vw;
  height: 4vh;
  border-radius: 0.5em;
  border: 1px solid var(--cor-preto);
}

.erro_senha,
.input_senha {
  width: 17vw;
  height: 4.3vh;
  border-radius: 0.5em;
  border: 1px solid var(--cor-preto);
  display: flex;
  align-items: center;
  justify-content: center;
}

.erro_senha button,
.input_senha button {
  width: 15%;
  height: 100%;
  border: none;
  display: flex;
  cursor: pointer;
  align-items: center;
  background-color: transparent;
}
.erro_senha button img,
.input_senha button img {
  width: 80%;
}

.erro_senha input,
.input_senha input {
  width: 80%;
  height: 85%;
  border: none;
}

.erro_senha input:focus,
.input_senha input:focus {
  outline: none;
}

.erro > input {
  border: 2px solid var(--cor-vermelho) !important;
}

.erro > input:focus{
  outline: 1px solid var(--cor-vermelho);
}

.erro_senha {
  border: 2px solid var(--cor-vermelho) !important;
}

.texto_erro {
  color: var(--cor-vermelho);
}

.img_instituto p{
  margin-top: 5em;
}`, "",{"version":3,"sources":["webpack://./src/paginas/Login.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,oBAAoB;EACpB,2BAA2B;EAC3B,4BAA4B;EAC5B,uCAAuC;AACzC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,wBAAwB;EACxB,uCAAuC;EACvC,eAAe;AACjB;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,aAAa;AACf;;AAEA;;EAEE,WAAW;EACX,WAAW;EACX,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,oBAAoB;EACpB,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,UAAU;EACV,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".containerLogin {\n  height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: space-evenly;\n}\n\n.caixa_img {\n  width: 40vw;\n  height: 94vh;\n  margin-top: 3em;\n  display: flex;\n  justify-content: end;\n  border-top-left-radius: 2em;\n  border-top-right-radius: 2em;\n  background-color: var(--cor-roxoEscuro);\n}\n\n.caixa_img img {\n  width: 35vw;\n}\n\n.caixa_usuario {\n  width: 30vw;\n  margin-top: 6em;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  font-family: \"Inter\";\n}\n\n.caixa_usuario img{\n  width: 35%;\n}\n\n.caixa_usuario > button {\n  width: 17vw;\n  height: 4.5vh;\n  margin: 1.5em;\n  font-size: 1.1em;\n  border-radius: 0.5em;\n  border: none;\n  color: var(--cor-branco);\n  background-color: var(--cor-roxoEscuro);\n  cursor: pointer;\n}\n\n.erro label,\n.caixa_input label {\n  font-size: 1em;\n  margin-top: 1em;\n  margin-bottom: 1em;\n  display: flex;\n}\n\n.erro > input,\n.caixa_input > input {\n  width: 17vw;\n  height: 4vh;\n  border-radius: 0.5em;\n  border: 1px solid var(--cor-preto);\n}\n\n.erro_senha,\n.input_senha {\n  width: 17vw;\n  height: 4.3vh;\n  border-radius: 0.5em;\n  border: 1px solid var(--cor-preto);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.erro_senha button,\n.input_senha button {\n  width: 15%;\n  height: 100%;\n  border: none;\n  display: flex;\n  cursor: pointer;\n  align-items: center;\n  background-color: transparent;\n}\n.erro_senha button img,\n.input_senha button img {\n  width: 80%;\n}\n\n.erro_senha input,\n.input_senha input {\n  width: 80%;\n  height: 85%;\n  border: none;\n}\n\n.erro_senha input:focus,\n.input_senha input:focus {\n  outline: none;\n}\n\n.erro > input {\n  border: 2px solid var(--cor-vermelho) !important;\n}\n\n.erro > input:focus{\n  outline: 1px solid var(--cor-vermelho);\n}\n\n.erro_senha {\n  border: 2px solid var(--cor-vermelho) !important;\n}\n\n.texto_erro {\n  color: var(--cor-vermelho);\n}\n\n.img_instituto p{\n  margin-top: 5em;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
